import { Metamodel } from 'app/model/base/model';
import { S3StoreReadSettings } from './s3-store-read-settings';

import { GoogleCloudStorageLinkedService } from 'app/model/linkedservice/google-cloud-storage.linkedservice';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.googleCloudStorage.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(GoogleCloudStorageLinkedService)
    }
})

export class GoogleCloudStorageStoreReadSettings extends S3StoreReadSettings {
}
